import LegalPage from "@/components/LegalPage";

const SECTIONS = [
    {
        title: "Responsable du traitement",
        paragraphs: [
            "Le responsable du traitement des données personnelles collectées sur ce site est la société ABITA MULTISERVICES, EURL, exploitant la marque ERADIKBREIZH, RCS Rennes 100 801 877.",
            "Contact : contact@eradikbreizh.fr, 02 55 99 22 43.",
        ],
    },
    {
        title: "Données collectées",
        paragraphs: [
            "Via notre formulaire de demande de devis, nous collectons uniquement : votre nom, votre numéro de téléphone, votre adresse email, votre ville, le type de nuisible concerné et la description de votre situation.",
            "Aucune autre donnée personnelle n'est collectée, et aucune donnée sensible ne vous est demandée.",
        ],
    },
    {
        title: "Finalités et base légale",
        paragraphs: [
            "Vos données sont utilisées exclusivement pour : répondre à votre demande de devis, assurer le suivi de votre intervention, gérer notre relation commerciale, et réaliser des statistiques internes.",
            "Ces traitements reposent sur l'exécution de mesures précontractuelles (votre demande de devis) et sur notre intérêt légitime à gérer notre relation client, conformément au Règlement (UE) 2016/679 (RGPD).",
        ],
    },
    {
        title: "Durée de conservation",
        paragraphs: [
            "Vos données sont conservées pendant une durée maximale de 3 ans à compter de notre dernier contact avec vous, puis sont supprimées ou anonymisées.",
        ],
    },
    {
        title: "Partage des données",
        paragraphs: [
            "Vos données sont strictement confidentielles. Elles ne sont ni vendues, ni louées, ni partagées avec des tiers à des fins commerciales. Seuls nos prestataires techniques contribuant au fonctionnement du site (hébergement, prise de rendez-vous en ligne) peuvent y avoir accès, dans la limite de leur mission.",
        ],
    },
    {
        title: "Vos droits",
        paragraphs: [
            "Conformément au RGPD et à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée, vous disposez des droits suivants sur vos données : accès, rectification, effacement, opposition, limitation du traitement et portabilité.",
            "Pour exercer ces droits, écrivez à contact@eradikbreizh.fr en précisant votre demande. Nous y répondrons dans un délai maximal d'un mois.",
            "Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        ],
    },
    {
        title: "Cookies",
        paragraphs: [
            "Ce site n'utilise que des cookies et stockages techniques strictement nécessaires à son fonctionnement (mémorisation de votre choix concernant le bandeau d'information).",
            "Aucun cookie publicitaire, de mesure d'audience ou de suivi tiers n'est déposé sur votre appareil. Conformément aux recommandations de la CNIL, ces cookies strictement nécessaires ne requièrent pas votre consentement préalable.",
        ],
    },
    {
        title: "Sécurité",
        paragraphs: [
            "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de protéger vos données personnelles contre toute perte, utilisation abusive, accès non autorisé, divulgation ou destruction.",
        ],
    },
];

const PolitiqueConfidentialite = () => (
    <LegalPage
        testid="confidentialite-page"
        tag="RGPD & CNIL"
        title="Politique de"
        accent="confidentialité"
        intro="Comment nous collectons, utilisons et protégeons vos données personnelles, et quels sont vos droits. Conforme au Règlement Général sur la Protection des Données (RGPD)."
        sections={SECTIONS}
        seoTitle="Politique de confidentialité (RGPD) | Eradikbreizh"
        seoDescription="Politique de confidentialité Eradikbreizh : données collectées via le formulaire de devis, aucun cookie publicitaire, durée de conservation, vos droits d'accès et de suppression. Conforme RGPD."
    />
);

export default PolitiqueConfidentialite;
